import React, { Component } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

import locale from './EnterAddress.locale';
import ContactFooter from './ContactFooter';

import * as availabilityApi from '../availabilityApi';

import InputInsideLabel from '../../../FormElements/InputInsideLabel';
import DropdownInsideLabel from '../../../FormElements/DropdownInsideLabel';
import usStates from '../../../../helpers/usStates';

class EnterAddress extends Component {
  constructor(props) {
    super(props);

    this.state = {
      address: this.props.address,
    };
  }
  componentDidMount = () => {
    document.getElementById('line1').focus();
  };

  onChange = (e) => {
    const newAddress = Object.assign(this.state.address, { [e.target.name]: e.target.value });
    this.setState({ address: newAddress });
    this.updatedAddressDebounced();
  };

  canSubmit = () => this.props.address.zipCode !== '';

  updatedAddressDebounced = debounce(() => {
    this.props.updateAddress(this.state.address);
  }, 300);

  proceed = (e) => {
    e.preventDefault();
    this.props.loading();

    availabilityApi
      .verifyAddress(this.props.address)
      .then((response) => {
        const { data } = response;

        const { requiresConfirmation, existingAddress, validatedAddress } = data.result;

        const validationResult = {
          existingAddress,
          requiresConfirmation,
          address: validatedAddress,
          wasFound: data.succeeded,
        };

        this.props.verifiedAddress(validationResult);
        this.props.loaded();
        this.props.advance();
      })
      .catch((err) => {
        this.props.loaded();
        console.log(err); // eslint-disable-line no-console

        const validationResult = {
          existingAddress: false,
          requiresConfirmation: true,
          address: this.state.address,
          wasFound: false,
        };

        this.props.verifiedAddress(validationResult);
        this.props.advance();
      });
  };

  render() {
    return (
      <div>
        <div className="description">
          {locale.instructions}
        </div>
        <form className="enter-address">
          <InputInsideLabel
            name="line1"
            inputClassNames={['full-width']}
            value={this.props.address.line1}
            label="Address"
            onChange={this.onChange}
          />

          <InputInsideLabel
            name="line2"
            inputClassNames={['full-width']}
            value={this.props.address.line2}
            label="Address 2"
            onChange={this.onChange}
          />

          <div className="form-group">
            <InputInsideLabel
              name="city"
              classNames={['city']}
              value={this.props.address.city}
              label="City"
              onChange={this.onChange}
            />
            <div className="stateZip">
              <DropdownInsideLabel
                classNames={['state']}
                name="state"
                label="State"
                options={usStates}
                value={this.props.address.state}
                onChange={this.onChange}
              />
              <InputInsideLabel
                name="zipCode"
                classNames={['zipCode']}
                value={this.props.address.zipCode}
                label="Zip Code"
                onChange={this.onChange}
              />
            </div>
          </div>
          <button
            className="check-availability btn btn-primary full-width"
            onClick={this.proceed}
            disabled={!this.canSubmit()}
          >
            Check Availability
          </button>
          <span className="desktop-tablet-only">
            <ContactFooter />
          </span>
          <span className="enter-address mobile-only">
            <ContactFooter />
          </span>
        </form>
      </div>
    );
  }
}

EnterAddress.propTypes = {
  updateAddress: PropTypes.func.isRequired,
  address: PropTypes.shape({
    line1: PropTypes.string,
    line2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.string,
  }),
  loading: PropTypes.func.isRequired,
  loaded: PropTypes.func.isRequired,
  verifiedAddress: PropTypes.func.isRequired,
  advance: PropTypes.func.isRequired,
};

EnterAddress.defaultProps = {
  address: {
    line1: '',
    line2: '',
    city: '',
    state: '',
    zipCode: '',
  },
};

export default EnterAddress;
